import { Client } from "@core/Client"
import { Logic } from "@core/Logic/Logic";
import { setVirtualWheel } from "@core/Utils/Constants"
import { IMAXAVirtualRouletteLoadGame } from "IMAXAVirtualRoulette/Sources/Scenes/LoadGame"

setVirtualWheel(true);

//https://www.html5gamedevs.com/topic/36805-image-is-pixelated/
new Client("IMAXA Virtual Roulette", {
	scale: {
		parent: 'game',
		mode: Phaser.Scale.NONE,
		width: window.innerWidth * window.devicePixelRatio,
		height: window.innerHeight * window.devicePixelRatio,
		autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
	},
	dom: {
		createContainer: true
	},
	render: {
		desynchronized: true,
		powerPreference: "high-performance",
		antialias: true,
		antialiasGL: true
	},
	type: Phaser.AUTO,
	parent: "game",
	scene: [IMAXAVirtualRouletteLoadGame]
}, Logic)
